<div class="loader-button loader-8">
    <div class="line line1"></div>
    <div class="line line2"></div>
    <div class="line line3"></div>
</div>